function getDay(date) {
  const daysOfWeek = ['일', '월', '화', '수', '목', '금', '토'];
  let i = new Date(date).getDay(date);
  return daysOfWeek[i];
}

function getMonth(date) {
  const monthName = [
    '1월',
    '2월',
    '3월',
    '4월',
    '5월',
    '6월',
    '7월',
    '8월',
    '9월',
    '10월',
    '11월',
    '12월',
  ];
  let i = new Date(date).getMonth(date);
  return monthName[i];
}

function getHeaderDate(date) {
  let month = getMonth(date);
  let year = new Date(date).getFullYear(date);
  return `${year}년 ${month}`;
}

export { getDay, getMonth, getHeaderDate };
